import { render, staticRenderFns } from "./WelcomeScreenConfig.vue?vue&type=template&id=5af618f3&"
import script from "./WelcomeScreenConfig.vue?vue&type=script&lang=js&"
export * from "./WelcomeScreenConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports